<div *ngIf="!editmembership">
  <div class="row" style="border-bottom:1px dotted lightgrey;">
    <div class="col-md-6">
      <a *ngIf="can_change_primary_institution" href="#" (click)="changePrimaryInstitution(); $event.preventDefault();"><button class="btn border">Byt primärinstitution</button></a>
    </div>
    <div class="col-md-6">
      <label class="form-check-label">
        <mat-checkbox (change)="showall = !showall" [ngClass]="(mobiledevice) ? 'pull-left':'pull-right'" checked="showall">Nuvarande</mat-checkbox>
      </label>
    </div>
  </div>
  <br>
  <div *ngIf="!editmembership && !addmembership && !changeprimaryinstitution && !terminatemembership && !terminatemembershipcamp">
    <div *ngFor="let memship of memberships">
      <div class="row">
        <div *ngIf="!showall && (memship.endDate | date: 'yyyy-MM-dd') === '9999-12-31'" class="col-sm-7 col-md-5">
          <a [routerLink]="['/institutions/id/', memship.institution.id]">{{memship.institution.shortName}}:
            {{memship.institution.name}}</a>
        </div>
        <div *ngIf="showall" class="col-sm-7 col-md-5">
          <a [routerLink]="['/institutions/id/', memship.institution.id]">{{memship.institution.shortName}}:
            {{memship.institution.name}}</a>
        </div>
        <div class="col-sm-5 col-md-5">
          <div *ngIf="showall && (memship.endDate | date: 'yyyy-MM-dd') !== '9999-12-31'">{{memship.startDate | date:
            'yyyy-MM-dd'}} -- {{memship.endDate | date: 'yyyy-MM-dd'}} <i *ngIf="!mobiledevice && (memship.userCanEditMemberMembership) && (selectedrole.roleId===12 || selectedrole.roleId===13)" (click)="confirmDeleteMembership(memship);" class="fa fa-trash"
              style="margin-top:3px;margin-left:10px;color:lightgrey;" title="Radera medlemskap i {{memship.institution.shortName}}  -  {{memship.institution.name}}"></i> <i
              *ngIf="showall && (memship.endDate | date: 'yyyy-MM-dd') !== '9999-12-31' && !mobiledevice && memship.userCanEditMemberMembership" class="fa fa-pencil-square-o pull-right" style="margin-top:3px;margin-left:10px;color:#920000;" title="Ändra"
              (click)="edit(memship);editmembership=true"></i>
          </div>
          <div *ngIf="(memship.endDate | date: 'yyyy-MM-dd') === '9999-12-31'">{{memship.startDate | date:
            'yyyy-MM-dd'}} --<i *ngIf="!mobiledevice && memship.userCanEditMemberMembership" class="fa fa-pencil-square-o pull-right" style="margin-top:3px;margin-left:10px;color:#920000;" title="Ändra" (click)="edit(memship);editmembership=true"></i><i
              *ngIf="!mobiledevice && memship.institution.id !== 446 && (memship.userCanEndCampMembership||memship.userCanTerminateOrderMembership) " (click)="terminateMembership2(memship)" class="fa fa-chain-broken pull-right" style="margin-top:3px;margin-left:20px;color:#920000;"
              title="Avsluta medlemskap i {{memship.institution.shortName}}  -  {{memship.institution.name}}"></i>
            <i *ngIf="!mobiledevice && (memship.userCanEditMemberMembership) && (selectedrole?.roleId===12 || selectedrole?.roleId===13)" (click)="confirmDeleteMembership(memship);" class="fa fa-trash pull-right" style="margin-top:3px;margin-left:10px;color:#920000;"
              title="Radera medlemskap i {{memship.institution.shortName}}  -  {{memship.institution.name}}"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Ändra medlemskap" [(visible)]="editmembership" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-membershipedit [membership]=membershipedit (closeEdit)="closeEdit($event)"></app-membershipedit>
</p-dialog>
